import { useEffect, useState } from "react"

const useData = () => {

    const [data,setData] = useState(null)

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch("/Data/Data.json")
            const result = await response.json()
            setData(result)
            console.log(result);
            
        }
        fetchData()
    },[])
    return data
}

export default useData